export default class CashierRefunds {
  constructor(props) {
    this.props = props;
    this.el = $('#CashierRefunds-Component');
    if (!this.el.length) { return false; }



    this.btnReservationSubmit = this.el.find('#btnReservationSubmit');
    this.orderId = this.el.find('#orderid');
    this._reservationSubmit = this._reservationSubmit.bind(this);
    this.btnReservationSubmit.on('click', this._reservationSubmit);
  }



  _reservationSubmit(e) {
    e.preventDefault();

    console.log(this.orderId.val());
    $.ajax({
      type: "POST",
      url: '/Cashier/GetReservationOrder/',
      data: { orderId: this.orderId.val(), orderItemIds: [] },
      success: function (data) {
        window.location.href = '/Cart';
        return false;
      },
      error: function () {
        alert('A error');
        return false;
      }
    });
    return false;
  }


}